// Booksy configuration
// Replace this with your real Booksy profile URL when ready.
// Find it in: Booksy Biz app → Profile → "Copy profile link"
// Example: https://booksy.com/en-us/1234567_mcneal-cutz_barber-shop_brooklyn

export const BOOKSY_URL =
  process.env.REACT_APP_BOOKSY_URL ||
  "https://booksy.com/en-us/?utm_source=mcnealcutz-site";

export const BOOKSY_CONFIGURED = Boolean(process.env.REACT_APP_BOOKSY_URL);
